// Production defaults. Override per environment with REACT_APP_* variables
// (see .env.example) so a local/staging build cannot pair a live Stripe key
// with a test backend, or vice versa.
export const API_URL =
  process.env.REACT_APP_API_URL || 'https://api.itsallaboutheoptions.com/api';
export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || 'wss://api.itsallaboutheoptions.com:6001';
export const TRADE_FLASH_SOCKET_URL =
  process.env.REACT_APP_TRADE_FLASH_SOCKET_URL || 'wss://api.itsallaboutheoptions.com:6001/tradeflash';

// export const API_URL = 'https://allaboutheoptions.test/api'
// export const SOCKET_URL = 'ws://allaboutheoptions.test/socket.io/';
// export const TRADE_FLASH_SOCKET_URL = 'ws://localhost:7001/tradeflash'

// For Local Testing 
// export const API_URL = 'http://localhost:8000/api';   // agar php artisan serve 8000 pe chal raha ho
// export const SOCKET_URL = 'ws://localhost:7001';
// export const TRADE_FLASH_SOCKET_URL = 'ws://localhost:7001/tradeflash';
// Must belong to the same Stripe account (live vs test) as the backend's
// STRIPE_SECRET, otherwise confirmCardSetup fails with "No such setupintent".
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  'pk_live_51OZxhhElQu0OoB1S9cw2Atn3bOn2eSafGFJhSbFUrE2xjkeTgEP6WsNhz2cC9KIQ9PXDxBhrWncAMbSnlguPOHds00XbSLrW2e';

export const FACEBOOK_APP_ID = "9558663540853784"
export const GOOGLE_CLIENT_ID = "115181365241-2ihempknf58hd5appbfsa1g5jlt4pr3t.apps.googleusercontent.com"
export const POLYGON_API_KEY = "5uVKIElZBkVZritFpX9MOPqpDqwCn2il"
export const RECAPTCHA_SITE_KEY = "6LcQd20rAAAAAF5bJxhq6iau12Zj4YrBXJNKyD9U"
